import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { Tooltip, Typography } from 'src/components/common';
import { textEllipsis } from 'src/utils';
import { TTextEllipsisResponse } from 'src/utils/textEllipsis/textEllipsis.types';
import { useAppDispatch } from 'src/store/hooks';
import { resetMessages } from 'src/store/chat/chat.slice';
import { TDiscussionTypes } from 'src/components/chat/chat.type';

import { TDiscussionGroupItemProps } from './discussionGroupItem.types';
import './discussionGroupItem.scss';

const DiscussionGroupItem = ({
  group,
  groupId,
  discussionType,
  ideaId
}: TDiscussionGroupItemProps) => {
  // Hooks
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const groupTitleEllipsis: TTextEllipsisResponse = textEllipsis({
    text: group?.groupName,
    charLimit: 20
  });

  const viewGroupDiscussion = () => {
    dispatch(resetMessages());

    const { pathname } = window.location;
    const chatType: TDiscussionTypes = 'ideaGroup';
    const path: string =
      pathname +
      `?id=${ideaId}&tab=discussion&chatType=${chatType}&groupId=${group?.id}&groupName=${group?.groupName}`;

    navigate(path);
  };

  return (
    <Tooltip
      text={group?.groupName}
      conditionToDisplay={groupTitleEllipsis?.hasEllipsis}
      limitWidth
    >
      <Typography
        as="p"
        variant="body-2"
        fontWeight="semiBold"
        className={classNames('discussion-group-item', {
          'discussion-group-item--is-active':
            group?.id === groupId && discussionType === 'ideaGroup'
        })}
        onClick={viewGroupDiscussion}
      >
        {groupTitleEllipsis?.text}
      </Typography>
    </Tooltip>
  );
};

export default DiscussionGroupItem;
